import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import AuthReducer from "./Reducer/AuthReducer";
import Eventreducer from "./Reducer/Eventreducer";
import { GuestReducer } from "./Reducer/GuestReducer";
import { ContactReducer } from "./Reducer/ContactReducer";
import { EmailReducer } from "./Reducer/EmailReducer";
import ReviewReducer from "./Reducer/ReviewReducer";
import PaymentReducer from "./Reducer/PaymentReducer";

const rootReducer = combineReducers({
  Auth: AuthReducer,
  Create: Eventreducer,
  Guest: GuestReducer,
  Contact: ContactReducer,
  Email: EmailReducer,
  Review: ReviewReducer,
  Payment: PaymentReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
